import { ReactElement } from "react";
import Skeleton from "react-loading-skeleton";
import ProjectSelectTable from "../ProjectSelectTable";

interface ProjectContentProps {
  isLoading: boolean;
  isLoadingDelete: boolean;
  tableData: any[];
  columns: any[];
  isError: boolean;
}

const ProjectContent = ({ 
  isLoading, 
  isLoadingDelete, 
  tableData, 
  columns, 
  isError 
}: ProjectContentProps): ReactElement => {
  if (isLoadingDelete || isLoading) {
    return (
      <div>
        {tableData?.map((_, index) => (
          <Skeleton key={index} width="100%" containerClassName="form-row-skeleton" />
        ))}
      </div>
    );
  }

  if (isError) {
    return (
      <span className="error fs-13 pb-2">
        An error occurred while fetching projects data
      </span>
    );
  }

  return <ProjectSelectTable data={tableData} columns={columns} />;
};

export default ProjectContent; 